import { Container, Row, Col } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";

export default function GuiaReciclagem() {
  return (
    <section id="reciclagem" className="py-5">
      <Container>
        <Row className="text-center mb-5">
          <Col>
            <h2 className="display-5 fw-bold text-dark mb-3">
              Guia de Reciclagem
            </h2>
            <p className="lead text-muted">
              Descubra quais materiais podem ser reciclados
            </p>
          </Col>
        </Row>
        
        {/* Adicionei 'd-flex' na Row para garantir comportamento flex, embora o padrão já seja */}
        <Row className="g-4 justify-content-center">
          <Col lg={5} md={6}>
            {/* A classe 'h-100' aqui é o segredo */}
            <div className="reciclagem-card-moderno positivo h-100">
              <div className="card-content">
                <h3
                  className="d-flex justify-content-center align-items-center mb-4"
                  style={{ color: "#2e7d32" }}
                >
                  <i className="fas fa-check-circle fa-lg me-2"></i>
                  <span>Pode Reciclar</span>
                </h3>
                <ul className="materials-list">
                  <li>Papel limpo</li>
                  <li>Papelão em Geral</li>
                  <li>Embalagens de Vidro e vidros em Geral</li>
                  <li>Embalagens de Plásticos e plásticos em Geral</li>
                  <li>Latas e Embalagens de Alumínio</li>
                  <li>Latas e Embalagens de Aço</li>
                </ul>
              </div>
            </div>
          </Col>

          <Col lg={5} md={6}>
            {/* A classe 'h-100' aqui força este card a esticar igual ao vizinho */}
            <div className="reciclagem-card-moderno negativo h-100">
              <div className="card-content">
                <h3
                  className="d-flex justify-content-center align-items-center mb-4"
                  style={{ color: "#c62828" }}
                >
                  <i className="fas fa-ban fa-lg me-2"></i>
                  <span>Não Reciclar</span>
                </h3>
                <ul className="materials-list">
                  <li>Papel Higiênico Usado</li>
                  <li>Guardanapos Usados</li>
                  <li>Bitucas de Cigarro</li>
                  <li>Fraldas</li>
                  <li>Absorventes</li>
                  <li>Cotonetes</li>
                  <li>Resíduos Orgânicos em Geral</li>
                </ul>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}